import React from 'react'
import LogoCamelontaWhite from '../../images/logo-camelonta-primary-white.svg'
import LogoCamelontaRgb from '../../images/logo-camelonta-primary-rgb.svg'

interface Props {
  theme: 'Light' | 'Dark'
  scrollClass?: 'top' | 'scrolled'
}

export const Logotype: React.FC<Props> = ({ theme, scrollClass }) => {
  if (theme === 'Light' && scrollClass === 'top') {
    return (
      <>
        <img
          src={LogoCamelontaWhite}
          alt="Logotype"
          className={`logotype logotype--${theme}`}
        />
      </>
    )
  }
  return (
    <>
      <img
        src={LogoCamelontaRgb}
        alt="Logotype"
        className={`logotype logotype--${theme}`}
      />
    </>
  )
}
